import { useRoute } from 'vue-router';
import { getLocalizedRouteName } from '@sigma/common/routes/getLocalizedRouteName.js';
export function useLocalizedRoute() {
    const route = useRoute();
    return (locale) => {
        const routeLocale = route.meta.locale;
        const routeName = route.meta.name;
        const query = { ...route.query };
        if (routeLocale) {
            delete query.locale;
            return {
                ...route,
                query,
                name: getLocalizedRouteName(routeName, locale),
            };
        }
        query.locale = locale;
        return {
            ...route,
            query,
        };
    };
}
//# sourceMappingURL=useLocalizedRoute.js.map